import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgView = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 6.75c-3.48 0-6.558 2.465-8.466 4.58a.995.995 0 0 0 0 1.34C5.442 14.786 8.52 17.25 12 17.25c3.48 0 6.558-2.465 8.466-4.58a.994.994 0 0 0 0-1.34C18.558 9.215 15.48 6.75 12 6.75m-9.58 3.575C4.395 8.135 7.855 5.25 12 5.25s7.605 2.886 9.58 5.075a2.494 2.494 0 0 1 0 3.35c-1.975 2.19-5.434 5.075-9.58 5.075-4.145 0-7.605-2.886-9.58-5.075a2.494 2.494 0 0 1 0-3.35M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 12a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgView;
